import React from 'react'
import { StyleProp, StyleSheet, TextStyle, View, ViewProps } from 'react-native'

import { User } from '../../helper'
import { Color, Font } from '../../style'
import { Text } from '../typography'

const styles = StyleSheet.create({
  container: {
    width: 36,
    height: 36,
    borderRadius: 18,
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    fontFamily: Font.medium,
    color: Color.simplyWhite,
    fontSize: 14,
  },
})

const COLORS = [
  Color.collCopper,
  Color.refinedGreen,
  Color.greyBlue,
  Color.lightRefinedGreen,
  Color.modifiedGrey,
  Color.coffee,
  Color.calmGrey,
  Color.premiumBlack,
  Color.soothingPink,
  Color.lightPink,
]

const colorForRand = (rnd: number) => Math.floor(rnd * COLORS.length)

export interface Props extends ViewProps {
  name?: string
  email?: string
  textStyle?: StyleProp<TextStyle>
}
const Avatar = (props: Props) => {
  const { name, email, textStyle, style, ...otherProps } = props

  const backgroundColor = COLORS[colorForRand(User.randFromEmail(email))]
  const containerStyle = [styles.container, { backgroundColor }, style]
  return (
    <View style={containerStyle} {...otherProps}>
      <Text style={[styles.text, textStyle]}>{User.initialsForName(name)}</Text>
    </View>
  )
}

export default Avatar
